/* eslint-disable max-len, react/jsx-max-props-per-line, react/jsx-sort-props */
import PropTypes from "prop-types";
import React from "react";

const LockIcon = ({
  classes,
  height,
  width
}) => (
  <div className={classes} >
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 29" fill="none" className="mb-2 inline-block">
      <path d="M16.0002 20.0042C16.7365 20.0042 17.3335 19.4774 17.3335 18.8275C17.3335 18.1776 16.7365 17.6508 16.0002 17.6508C15.2638 17.6508 14.6668 18.1776 14.6668 18.8275C14.6668 19.4774 15.2638 20.0042 16.0002 20.0042Z" fill="#777777" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.3335 8.23704V11.7672H8.00016C6.5274 11.7672 5.3335 12.8209 5.3335 14.1206V23.5344C5.3335 24.8342 6.5274 25.8878 8.00016 25.8878H24.0002C25.4729 25.8878 26.6668 24.8342 26.6668 23.5344V14.1206C26.6668 12.8209 25.4729 11.7672 24.0002 11.7672H22.6668V8.23704C22.6668 4.98762 19.6821 2.35344 16.0002 2.35344C12.3183 2.35344 9.3335 4.98762 9.3335 8.23704ZM16.0002 4.70688C13.791 4.70688 12.0002 6.28738 12.0002 8.23704V11.7672H20.0002V8.23704C20.0002 6.28738 18.2093 4.70688 16.0002 4.70688ZM8.00016 14.1206V23.5344H24.0002V14.1206H8.00016Z" fill="#777777" />
    </svg>
  </div>
);

LockIcon.defaultProps = {"classes": ""};

LockIcon.propTypes = {
  "classes": PropTypes.string,
  "height": PropTypes.number.isRequired,
  "width": PropTypes.number.isRequired
};

export default LockIcon;
